<div class="contact-page modal">
    <form [formGroup]="codigoForm" class="theme-form" (keydown.enter)="$event.preventDefault()">
        <div class="container d-flex justify-content-center">
            <div class="col-10 p-5 modal-body">
                <button *ngIf="mostrandoCarga === false" class="close-button" (click)="closeModal()">X</button>
                <div class="col-sm-12 text-center">
                    <h3>Código para verificación de email</h3>
                    <p><strong>{{textoInstruccion}}</strong></p>
                    <div class="d-flex flex-column align-items-center mt-4">
                        <div class="col-4 d-flex gap-3 justify-content-center">
                            <input type="number" formControlName="cod1" class="form-control inputCode" id="cod1" required maxlength="1" (input)="onInput($event, 2)">
                            <input type="number" formControlName="cod2" class="form-control inputCode" id="cod2" required maxlength="1" (input)="onInput($event, 3)">
                            <input type="number" formControlName="cod3" class="form-control inputCode" id="cod3" required maxlength="1" (input)="onInput($event, 4)">
                            <input type="number" formControlName="cod4" class="form-control inputCode" id="cod4" required maxlength="1" (input)="onInput($event, 5)" (keyup.enter)="verificarCorreo()">
                        </div>
                        <span class="text-danger mb-2">{{txtError}}</span>
                    </div>
                    <p class="d-flex justify-content-center flex-wrap">
                        ¿No recibiste el código?&nbsp;<a (click)="enviarCodigo()" [ngStyle]="{ 'pointer-events': tiempoRestante > 0 ? 'none' : 'auto', 'cursor': tiempoRestante > 0 ? 'not-allowed' : 'pointer' }" style="transition: color 0.3s;">Volver a enviar código </a> 
                        <span *ngIf="tiempoRestante > 0">&nbsp;en {{ tiempoRestante }} segundos</span>
                    </p>
                </div>                    
                <div class="d-flex justify-content-center mt-3">
                    <button class="btn btn-solid mt-2" (click)="verificarCorreo()" [disabled]="codigoForm.invalid">
                        <span *ngIf="mostrandoCarga === false">Verificar</span>
                        <span class="d-flex" *ngIf="mostrandoCarga === true">
                            <div class="spinner"></div> &nbsp;&nbsp;
                            Verificando...
                          </span>
                    </button>
                </div>
            </div>
        </div>
    </form>
</div> 